import SendEmailPopup from './SendEmailPopup';

export default SendEmailPopup;
